// DO NOT DELETE BELOW - these must be imported to use these extensions across app
import './utils/behavior-subject.extensions';
import { Component, ElementRef, HostListener } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from '../environments/environment';
import { initializeApp } from 'firebase/app';
import { getAnalytics, setUserProperties } from 'firebase/analytics';
import { LoggingService } from './services/logging-service';
import { CanDeactivateState } from './services/guards/can-deactivate.guard';
import { filter, tap } from 'rxjs/operators';
import { InjectorService } from './services/injector.service';
import { ScreenService } from './services/screen-service.service';
import { BaseComponent } from './models/base/base-component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent extends BaseComponent {
  public isMobile$ = this.screenService.isMobile$;

  constructor(
    private router: Router,
    private loggingService: LoggingService,
    private screenService: ScreenService,
    private spinner: NgxSpinnerService,
    private injectorService: InjectorService, // Do not remove, or else injector service does not work.
    private el: ElementRef
  ) {
    super();
    // Config for Firebase
    const firebaseApp = initializeApp(environment.firebaseConfig);
    const analytics = getAnalytics(firebaseApp);
    const userProperties: { [key: string]: any } = {};
    userProperties.Platform = 'Dashboard';
    setUserProperties(analytics, userProperties);
    this.loggingService.setFirebaseAppInstance(firebaseApp, analytics);
    // Config for Abandon changes on back button
    window.onpopstate = () => (CanDeactivateState.defendAgainstBrowserBackButton = true);
    router.events
      .pipe(
        filter(e => e instanceof NavigationEnd),
        tap(() => (CanDeactivateState.defendAgainstBrowserBackButton = false))
      )
      .subscribe();
  }

  override setupViews() {
    this.onResize(window?.innerWidth);
    this.spinner.show();
  }

  override setupBindings() {
    this.router.events.subscribe(evt => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(windowInnerWidth?: number) {
    const width = windowInnerWidth || (this.el.nativeElement as HTMLElement).getBoundingClientRect().width;
    if (width > 0) {
      this.screenService.setWidth(width);
      this.screenService.setIsMobile(width < ScreenService.MOBILE_WIDTH);
    }
  }

  override destroy() {
    super.destroy();
    this.spinner.hide();
  }
}
